module.exports = "/assets/data/0335e6eecf0b7fa492a32ab21069ccd5-W1C.data.json";